import validate from "./validate";

export default function createPassError(pass1, pass2, params) {
    const min = params.PASSWORD_LENGTH
    if (pass1 !== pass2) {
        return 'Пароли должны совпадать'
    }
    if (pass1.length < min) {
        return 'Пароль должен быть не менее 6 символов длиной'
    }
    if (!validate('pass', pass1, params )) {
        let result = []
        if (params.PASSWORD_DIGITS === 'Y') {
            result.push('цифры')
        }
        if (params.PASSWORD_LOWERCASE === 'Y') {
            result.push('латинские символы нижнего регистра (a-z)')
        }
        if (params.PASSWORD_UPPERCASE === 'Y') {
            result.push('латинские символы верхнего регистра (A-Z)')
        }
        if (params.PASSWORD_PUNCTUATION === 'Y') {
            result.push('знаки пунктуации (,.<>/?;:\'"[]{}\\|`~!@#$%^&*()_+=-)')
        }
        if (result.length === 0) {
            return 'Недопустимые символы в пароле'
        } else {
            return 'Пароль должен содержать: ' + result.join(', ')
        }
    }
}